import { MerchantInfo } from 'common/types';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';

export const merchant = {
  // 查询二级商户信息
  getMerchantInfo: async () => {
    return await FastApiAxiosInstance.get<MerchantInfo>(`/mobile/api/v1/user/merchant/query`);
  },
  // 签约二级商户
  createMerchant: async (alipayAccount: string) => {
    return await FastApiAxiosInstance.post(`/mobile/api/v1/user/merchant/create`, {
      alipayAccount,
    });
  },
};
